import { reactive } from 'vue';
interface listDataType {
    name: string,
    path: string
}
export const listData: listDataType[] = reactive([
    {
        name: '首页',
        path: '/'
    },
    {
        name: '关于我们',
        path: '/about.html'
    },
    {
        name: '主营产品',
        path: '/products.html'
    },
    {
        name: '项目案例',
        path: '/performance.html'
    },
    {
        name: '合作伙伴',
        path: '/partner.html'
    },
    {
        name: '联系我们',
        path: '/contact.html'
    },
])